export function urlToDataWizard(): string {
  return "/rejestracja/dane";
}
